document.addEventListener('DOMContentLoaded', () => {
  
  // ✅ Prevent crash when window.theme is not defined
  window.theme = window.theme || {};
  window.theme.settings = window.theme.settings || { parallaxIntensity: 50 };

  if (!window.theme.shapesAnimationsInitialized) {
    const map = function (number, inMin, inMax, outMin, outMax) {
      return ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
    };

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    class ShapesAnimations {
      setPosition() {
        let oldPosition = this.position;
        this.position =
          (document.documentElement || document.body.parentNode || document.body)
            .scrollTop || window.pageYOffset;

        return oldPosition != this.position;
      }

      updatePosition(percentage, speed) {
        let value = speed * (100 * (1 - percentage));
        return Math.round(value);
      }

      cacheParallaxContainers() {
        for (let i = 0; i < this.parallaxContainers.length; i++) {
          const item = this.createParallaxItem(this.parallaxContainers[i]);
          this.parallaxItems.push(item);
        }
      }

      inViewport(element) {
        if (!element || element.nodeType !== 1) return false;

        const html = document.documentElement;
        const rect = element.getBoundingClientRect();

        return (
          rect.width > 0 &&
          rect.height > 0 &&
          rect.bottom >= 0 &&
          rect.right >= 0 &&
          rect.left <= html.clientWidth &&
          rect.top <= html.clientHeight
        );
      }

      createParallaxItem(el) {
        const id = el.getAttribute('data-parallax-id');
        const container = el;
        const item = el.querySelector('[data-parallax-element]');
        const speed = parseInt(el.getAttribute('data-parallax-speed')) * -1;

        const blockHeight = item?.clientHeight || item?.offsetHeight || item?.scrollHeight || 0;
        const isInViewPort = this.inViewport(el);

        return {
          id,
          container,
          item,
          height: blockHeight,
          speed,
          visible: isInViewPort,
        };
      }

      observeItems() {
        this.parallaxObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const parallaxItemIndex = this.parallaxItems.findIndex(
              (item) => item.id === entry.target.getAttribute('data-parallax-id')
            );
            if (parallaxItemIndex > -1) {
              this.parallaxItems[parallaxItemIndex].visible = entry.isIntersecting;
            }
          });
        }, {
          rootMargin: '0px 0px 20% 0px',
          threshold: 0,
        });

        for (let i = 0; i < this.items.length; i++) {
          this.parallaxObserver.observe(this.items[i]);
        }
      }

      animate() {
        for (let i = 0; i < this.parallaxContainers.length; i++) {
          if (this.parallaxItems[i].visible) {
            const scrollPercentage =
              (this.screenHeight - this.parallaxItems[i].container.getBoundingClientRect().top) /
              (this.screenHeight + this.parallaxItems[i].height) - 0.5;

            const baseValue = this.intensity *
              (this.parallaxItems[i].speed * (scrollPercentage * 100));

            const valueY = Math.round(baseValue * 100 + Number.EPSILON) / 100;

            if (this.parallaxItems[i].item) {
              this.parallaxItems[i].item.style.transform = `translateY(${valueY}px)`;
            }
          }

          this.parallaxContainers[i].classList.add('animated');
        }

        for (let i = 0; i < this.rotateItems.length; i++) {
          this.rotateItems[i].style.transform = `rotate(${window.pageYOffset / 3}deg)`;
        }

        this.firstAnimate = true;
      }

      initParallax() {
        this.screenHeight = window.innerHeight;
        this.parallaxItems = [];
        this.parallaxContainers = document.querySelectorAll('[data-parallax-container]');

        this.setPosition();
        this.cacheParallaxContainers();

        this.intensity = map(window.theme.settings.parallaxIntensity, 0, 100, 1, 110) / 100;

        this.animate();
        document.addEventListener(
          'scroll',
          () => {
            if (this.setPosition()) {
              requestAnimationFrame(this.animate.bind(this));
            }
          },
          { passive: true }
        );
      }

      // ✅ Track mouse and move sticker elements
     trackMouseForStickers() {
      console.log('tracking sticker mouse');

      const stickerElements = document.querySelectorAll('[data-sticker-mousemove]');
      // if (!stickerElements.length) return;

      window.addEventListener('mousemove', (e) => {
           console.log('tracking sticker mouse run');
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        const percentX = (e.clientX - centerX) / centerX;
        const percentY = (e.clientY - centerY) / centerY;

        stickerElements.forEach((el) => {
          const moveAmount = parseFloat(el.getAttribute('data-mouse-move-offset')) || 50;

          const translateX = percentX * moveAmount;
          const translateY = percentY * moveAmount;

          el.style.transform = `translate(calc(-50% + ${translateX}%), calc(-50% + ${translateY}%))`;
        });
      });
    }


      init() {
        this.items = document.querySelectorAll('[data-parallax-container]');
        this.rotateItems = document.querySelectorAll('.sticker-rotate-when-scrolling');

        this.observeItems();
        this.initParallax();
        this.trackMouseForStickers();

        window.addEventListener('resize', () => {
          if (this.enable_parallax) {
            this.initParallax();
          }
        });

        // Optional: MutationObserver fallback for dynamic section rendering
        const mutationHandler = debounce(() => {
          this.init();
        }, 500);

        document.addEventListener('dev:hotreloadmutation', mutationHandler);
      }
    }

    const shapesAnimations = new ShapesAnimations();

    if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      shapesAnimations.init();

      document.addEventListener('shopify:section:load', () => {
        shapesAnimations.init();
      });
    }

    window.theme.shapesAnimationsInitialized = true;
  }
});
